import { connect } from "react-redux";
import { batchActions } from "redux-batched-actions";
import settings from "settings";
import { clearAutocompleteState, fetchAutompleteResult } from "../Actions/ActionAutocomplete";
import { joinClan } from "../Actions/ActionInvites";
import { appendTermToHistory, changeBattleType, changePage, changeTerm, clearSearchState, fetchSearchResult } from "../Actions/ActionSearch";
import Search from "../Components/Search/Search";
import { getAccountSearchHistory } from "../Reducers/ReducerSearchHistory";

const mapStateToProps = state => {
  return {
    autocomplete: state.autocomplete,
    battleTypes: settings.battleTypes,
    currentAccount: state.currentAccount,
    searchHistory: getAccountSearchHistory(state.searchHistory, state.currentAccount.id),
    searchResult: state.searchResult,
    root: state.urls.root
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSearchInputChange: term => {
      return dispatch(fetchAutompleteResult(term));
    },
    onSubmit: term => {
      dispatch(changeTerm(term));
      return dispatch(fetchSearchResult());
    },
    joinClan(clan, invite) {
      dispatch(joinClan(clan, invite, 'clan_search'));
    },
    onReloadClick: () => {
      return dispatch(fetchSearchResult());
    },
    onBattleTypeChange: selectedBattleType => {
      dispatch(changeBattleType(selectedBattleType));
      return dispatch(fetchSearchResult());
    },
    onPageChanged: page => {
      dispatch(changePage(page));
      return dispatch(fetchSearchResult());
    },
    clearState: () => {
      dispatch(batchActions([clearAutocompleteState(), clearSearchState()]));
    },
    onAutocompleteItemClick: (item, accountId) => {
      dispatch(appendTermToHistory(item, accountId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);